const locationOrParty = require('../locationOrParty');
const { getTranslationDictionary } = require('core');

function startAction(isActual, location, party) {
	const translationDictionary = getTranslationDictionary();
    const place = locationOrParty(location, party);
    const propertyName = `pick${isActual ? 'ed' : ''}Up${place ? 'At' : ''}Event`;
    return translationDictionary[propertyName];
}

function stopAction(isActual, location, party) {
	const translationDictionary = getTranslationDictionary();
    const place = locationOrParty(location, party);
	const propertyName = `deliver${isActual ? 'ed' : ''}${place ? 'To' : ''}Event`;
	return translationDictionary[propertyName];
}

module.exports = {startAction, stopAction};
